import React from 'react';

import { Box, Flex } from '@lightspeed/flame/Core';
import { IconClockOutline } from '@lightspeed/flame/Icon/ClockOutline';
import { Text } from '@lightspeed/flame/Text';

import { DaysLeft } from './DaysLeft';

export type MessageProps = {
  offerAmount?: string;
  daysLeft?: number;
  expiryDate?: string;
};

export const Message: React.FC<MessageProps> = ({ offerAmount, daysLeft, expiryDate }) => {
  const getRemainingDaysLeftInOfferComponent = (remainingDaysLeftForOffer: number) => {
    if (remainingDaysLeftForOffer <= 0 || remainingDaysLeftForOffer > 7) {
      return null;
    }

    return (
      <Box mr={['0', '1']} mb={['2', '0']} flexShrink={0}>
        <DaysLeft>
          <Flex alignItems="center">
            <Box mr="1">
              <IconClockOutline />
            </Box>
            {remainingDaysLeftForOffer === 1 ? (
              <Text as="span">1 day left</Text>
            ) : (
              <Text as="span">
                <var className="notranslate">{remainingDaysLeftForOffer}</var>
                {'\u00A0'}days left
              </Text>
            )}
          </Flex>
        </DaysLeft>
      </Box>
    );
  };

  return (
    <Box mx={['0', '4']} flexGrow={1}>
      <Text fontSize="24px" fontWeight="700" color="textHeading" as="div" mb="2">
        You{'\u2019'}re eligible for up to <var className="notranslate">{offerAmount}</var>
        {'\u00A0'}with Lightspeed Capital
      </Text>
      <Flex flexDirection={['column', 'row']} width={1} alignItems={['start', 'center']}>
        {getRemainingDaysLeftInOfferComponent(daysLeft ?? 0)}
        <Text size="normal" color="textDimmed" as="div">
          Flexible funding to grow your business. Available until{' '}
          <var className="notranslate">{expiryDate}</var>
        </Text>
      </Flex>
    </Box>
  );
};
